import { Card, message, Spin, Tag } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { useLocation } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";

const ViewInvoice = () => {
  const location = useLocation();

  const invoice = location.state?.invoice;
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [invoiceProducts, setInvoiceProducts] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const getInvoiceDetails = async () => {
    try {
      setPageLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}invoice/GetInvoice/${invoice.id}`,
      );

      const data = await response.json();

      if (data.Status) {
        setInvoiceDetails(data.Invoice);

        const mergedProducts = data.Itemable.map((item, index) => ({
          ...item,
          ...(data.RelatedItems[index] || {}),
        }));

        setInvoiceProducts(mergedProducts);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    getInvoiceDetails();
  }, [invoice]);

  return (
    <Base>
      {pageLoading ? (
        <div className="text-center mt-5">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="card shadow-sm border-0 mb-3">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h5 className="mb-1">
                    {invoiceDetails.prefix}-{invoiceDetails.number}
                  </h5>

                  <small className="text-muted">
                    <i className="fas fa-building me-2"></i>
                    {invoiceDetails.ClientName}
                  </small>
                </div>
                <div className="d-flex flex-column">
                  <Tag color="orange">
                    <i className="fas fa-clock me-1"></i>
                    Unpaid
                  </Tag>
                  <small className="text-muted mt-2">
                    <i className="fas fa-user me-2"></i>
                    {invoiceDetails.AddedByName}
                  </small>
                </div>
              </div>
              <div className="row g-2">
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-calendar-alt text-primary me-2"></i>

                    <div>
                      <small className="text-muted d-block">Invoice Date</small>

                      <h6>
                        {dayjs(invoiceDetails.date).format("DD MMM YYYY")}
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-hourglass-end text-danger me-2"></i>

                    <div>
                      <small className="text-muted d-block">Due Date</small>

                      <h6>
                        {dayjs(invoiceDetails.duedate).format("DD MMM YYYY")}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card shadow-sm border-0 mb-3">
            <div className="card-body">
              <h6 className="mb-2">
                <i className="fas fa-map-marker-alt text-danger me-2"></i>
                Billing Address
              </h6>
              <div className="row">
                <div className="col-6 mb-2">
                  <i className="fas fa-road text-primary me-3 mt-1"></i>

                  <span>{invoiceDetails.billing_street}</span>
                </div>

                <div className="col-6 mb-2">
                  <i className="fas fa-city text-success me-3 mt-1"></i>

                  <span>{invoiceDetails.billing_city}</span>
                </div>

                <div className="col-6 mb-2">
                  <i className="fas fa-map text-warning me-3 mt-1"></i>

                  <span>{invoiceDetails.billing_state}</span>
                </div>

                <div className="col-6 d-flex">
                  <i className="fas fa-mail-bulk text-secondary me-3 mt-1"></i>

                  <span>{invoiceDetails.billing_zip}</span>
                </div>
              </div>
            </div>
          </div>
          {invoiceProducts.map((product, index) => {
            const amount = Number(product.qty) * Number(product.rate);

            return (
              <Card key={index} className="shadow-sm border-0 mb-3">
                <div className="d-flex justify-content-between">
                  <div>
                    <h6 className="mb-1">{product.description}</h6>

                    <small className="text-muted">{product.unit}</small>
                  </div>

                  <div className="text-end">
                    <div className="fw-bold">
                      ₹{Number(product.rate).toLocaleString()}
                    </div>

                    <small className="text-muted">per unit</small>
                  </div>
                </div>

                <hr className="my-1" />

                <div className="row g-2 text-center">
                  <div className="col-auto">
                    <div className="bg-light rounded d-flex">
                      <small className="text-muted d-block">Qty :</small>

                      <strong>{product.qty}</strong>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="bg-light rounded d-flex">
                      <small className="text-muted d-block">Unit</small>

                      <strong>{product.unit}</strong>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="bg-success-subtle rounded d-flex">
                      <small className="text-muted d-block">Amount</small>

                      <strong>₹{amount.toLocaleString()}</strong>
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}

          <Card className="shadow-sm border-0 mb-3">
            <h6 className="mb-3">Invoice Summary</h6>

            <div className="d-flex justify-content-between mb-2">
              <span>Subtotal</span>

              <strong>
                ₹{Number(invoiceDetails.subtotal).toLocaleString()}
              </strong>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>Tax</span>

              <strong>
                ₹{Number(invoiceDetails.total_tax).toLocaleString()}
              </strong>
            </div>

            <hr />

            <div className="d-flex justify-content-between">
              <h6>Total</h6>

              <h5 className="text-success mb-0">
                ₹{Number(invoiceDetails.total).toLocaleString()}
              </h5>
            </div>
          </Card>
        </>
      )}

      <Footer />
    </Base>
  );
};

export default ViewInvoice;
